import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ProximityState = {
  isWristPointVisible: boolean;
  isWristPointHaloVisible: boolean;
  isWristGondolaPointVisible: boolean;
  isWristGondolaPointHaloVisible: boolean;
  isSkuSectionsVisible: boolean;
  wristPointHaloRadius: number;
  wristGondolaPointHaloRadius: number;
};

const initialState = (): ProximityState => ({
  isWristPointVisible: true,
  isWristPointHaloVisible: true,
  isWristGondolaPointVisible: true,
  isWristGondolaPointHaloVisible: true,
  isSkuSectionsVisible: true,
  wristPointHaloRadius: 150,
  wristGondolaPointHaloRadius: 150,
});

export const proximitySlice = createSlice({
  name: "proximity",
  initialState,
  selectors: {},
  reducers: {
    toggleWristPointVisibility(state) {
      state.isWristPointVisible = !state.isWristPointVisible;
    },
    toggleWristPointHaloVisibility(state) {
      state.isWristPointHaloVisible = !state.isWristPointHaloVisible;
    },
    toggleGondolaPointVisibility(state) {
      state.isWristGondolaPointVisible = !state.isWristGondolaPointVisible;
    },
    toggleGondolaPointHaloVisibility(state) {
      state.isWristGondolaPointHaloVisible =
        !state.isWristGondolaPointHaloVisible;
    },
    toggleSkuSectionsVisibility(state) {
      state.isSkuSectionsVisible = !state.isSkuSectionsVisible;
    },
    setWristPointHaloRadius(state, action: PayloadAction<number>) {
      state.wristPointHaloRadius = action.payload;
    },
    setWristGondolaPointHaloRadius(state, action: PayloadAction<number>) {
      state.wristGondolaPointHaloRadius = action.payload;
    },
  },
});

export const {
  toggleWristPointVisibility,
  toggleWristPointHaloVisibility,
  toggleGondolaPointVisibility,
  toggleGondolaPointHaloVisibility,
  toggleSkuSectionsVisibility,
  setWristPointHaloRadius,
  setWristGondolaPointHaloRadius,
} = proximitySlice.actions;
